import drawDoughnutChart from 'vendor/jquery.drawDoughnutChart';
import Swiper from 'swiper/dist/js/swiper';
import CountUp from 'countup';
import Waypoints from 'waypoints/lib/jquery.waypoints';

export default class HomePage {
    constructor() {

        this.data = [
            {
                title: "ZARADA",
                value: 0,
                valuePercentage: 63,
                color: "#e81010"
            },
            {
                title: "KULTURA",
                value: 0,
                valuePercentage: 52,
                color:  "#e81010"
            },
            {
                title: "FLEKSIBILNOST",
                value: 0,
                valuePercentage:50,
                color:  "#e81010"
            }
        ];
        this.init();

    }

    init() {
        this.onScrollAnim();
        this.sliderInit();
        this.chartDoughnouts();
        this.scrollTo();
        this.counterUp();
    }

    sliderInit() {
        const mySwiper = new Swiper ('.swiper-container', {
            // Optional parameters
            // direction: 'vertical',
            loop: true,

            // If we need pagination
            pagination: {
                el: '.swiper-pagination',
            },

            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            effect: 'fade',

            fadeEffect: {
                crossFade: true
            },

        })
    }

    chartDoughnouts() {
        const self = this;

        $(".js-chart-doughnut").each(function(index, value) {
            const $chart = $(this);

            $(this).waypoint(
                function(direction){
                    if(direction == "down") {
                        $chart.empty();
                        $chart.drawDoughnutChart([
                            { title: self.data[index].title, value: self.data[index].valuePercentage, color: self.data[index].color },
                            { title: "", value: (100 - parseInt(self.data[index].valuePercentage)), color: "#460971" }
                        ], {
                            segmentShowStroke : false,
                            segmentStrokeColor : "#460971",
                            segmentStrokeWidth : 0,
                            baseColor: "#460971",
                            baseOffset: 0,
                            edgeOffset : 10,//offset from edge of $this
                            percentageInnerCutout : 75,
                            summaryTitle: ``
                        });
                    }
                },
                { offset: '100%' }
            );

        });

    }

    scrollTo() {
        $('.js-scroll-to-btn').on('click touchstart', (ev) => {
            ev.preventDefault();

            let offset = 0;
            const scroolToAnchor = $(ev.currentTarget).attr('data-target'),
                scrollToOffset = 0;

            if (scrollToOffset) {
                offset = scrollToOffset;
            }

            if ($(scroolToAnchor).length) {
                TweenMax.to($('html, body'), 1, {
                    scrollTop: $(scroolToAnchor).offset().top,
                    ease: Power2.easeOut
                });
            }

        });
    }

    counterUp() {

        const options = {
            useEasing : true,
            useGrouping : true,
            separator : ',',
            decimal : '.',
            prefix : '',
            suffix : ''
        }

        $('.js-scroll-region').each(function() {
            const $self = $(this);

            $(this).waypoint(
                function(direction){
                    if(direction == "down") {
                        const scroll = new CountUp($self.find('.js-scroll-num').attr('id'), 0, parseInt($self.find('.js-scroll-num').data('number')), 0, 2.5, options);
                        if (!scroll.error) {
                            scroll.start();
                        } else {
                            console.error(scroll.error);
                        }
                    }
                },
                { offset: '100%' }
            );

        });
    }

    onScrollAnim() {

        let scroll = {
            ready: !1,
            init: function () {
                this.ready = !1,
                    $(".is_over").removeClass("is_over"),
                    this.$el = $(".js-scroll-fade-in"),
                    this.ready = !0;

                $(".js-is-in-viewport").each(function (e, i) {
                    let r = $(i),
                        n = r.offset().top;
                    r.addClass("is_over");
                });

            }, add: function () {
                this.$el = $(".js-scroll-fade-in"),
                    this.$elInViewport = $(".js-is-in-viewport")

            }, onReset: function () {
                window.scrollTo(0, 0),
                    TweenMax.to("body", .1, { scrollTo: { y: 0, autoKill: !1 }});

            }, onScroll: function (t) {

                this.$el.each(function (e, i) {
                    let r = $(i),
                        n = r.offset().top;
                    t > n && r.addClass("is_over")
                })
            }
        };

        scroll.init();

        $(window).on({
            resize: () => {
                let windowTop = $(window).scrollTop();
                scroll.ready && scroll.onScroll(windowTop + window.innerHeight - 150);
            }, scroll: () => {
                let windowTop = $(window).scrollTop();
                scroll.ready && scroll.onScroll(windowTop + window.innerHeight - 150);
            }
        });
    }
}


// WEBPACK FOOTER //
// ./static/js/pages/HomePage.js